module.exports = __webpack_public_path__ + "src/img/infoplayMax.f8331f91.png";